import type { ApplyReportTemplateRow } from "./applyReportTemplateRows";

export const filterApplyReportTemplateRowsByTemplate = ({
    rows,
    templateKey,
}: {
    rows: ApplyReportTemplateRow[];
    templateKey?: string;
}): ApplyReportTemplateRow[] => {
    if (templateKey === undefined) {
        return rows;
    }
    const matches = (row: ApplyReportTemplateRow) =>
        row.savedTemplateKey === templateKey;

    return rows.flatMap((client) => {
        const children = (client.children ?? []).filter(matches);
        return matches(client) || children.length > 0
            ? [{ ...client, children }]
            : [];
    });
};
